angular.module('unergie.main')
.controller('homeCtrl', ($interval, $uibModalStack, $scope, $state, $uibModal, $timeout, $rootScope, BoFeaturesService, Healthchecks, Roles,
    AuthService, AlertManager, AccountService, ApiUser, ReferencesService, OrganizationService, ErrorCatcher, DataAccessSearch, DataAccess,
    DataAccessVariables, ApiAdmin, SocketFactory, JiraConstants, JiraService, ModalService) => {
    const grdContractsMapping = BoFeaturesService.get('grdContractsMapping')
    $scope.searchString = $scope.searchString || ''
    $scope.alerts = AlertManager.alerts
    $scope.collapsed = localStorage.leftMenuCollapsed === 'true'
    $scope.isSearching = false
    $scope.isEnedisUp = 'unknown'
    $scope.canSeeAUNotif = BoFeaturesService.get('canSeeAUNotif')
    $scope.canSeeCapSupport = BoFeaturesService.get('canSeeCapSupport')
    $scope.canSeePRMSearch = BoFeaturesService.get('canSeePRMSearch')
    $scope.canSeePCESearch = BoFeaturesService.get('canSeePCESearch')
    $scope.canCreateNewIssue = BoFeaturesService.get('canCreateNewIssue')
    $scope.showSearch = () => BoFeaturesService.isFeatureOn('homeSearch')
    $scope.showBroadcast = () => BoFeaturesService.isFeatureOn('canBroadcast')
    $scope.showUserNotifications = () => BoFeaturesService.isFeatureOn('userNotifications')
    $scope.showEvents = BoFeaturesService.isFeatureOn('showEvents')
    $scope.canSeeVersionBand = BoFeaturesService.isFeatureOn('canSeeVersionBand')
    $scope.canBatchOperation = BoFeaturesService.isFeatureOn('canBatchOperation')

    $scope.countAU = 0
    $scope.hasNewUrgentCalls = false
    $rootScope.displayVersionBand = false

    const updateAUCount = function () {
        DataAccessVariables.get({ variables: 'JIRA_PROJECT_KEY' }).$promise.then((variables) => {
            // Fetch project epic issue
            const params = {}
            params.filter = () => ({
                issuetype: 'Task',
                status: '!10594',
                epicLink: 'SN2-824,SN2-823,SN2-822,SN2-1650,SN2-4581,SN2-4673',
            })
            return JiraService.getData(params, 'support', 'idContract').$promise.then((response) => {
                return DataAccessSearch({
                    in: [`id=${_.map(response.results.issues, `fields.idContract`).join(',')};` +
                    `account.id_grd_contract=${_.compact(_.map(grdContractsMapping, (v, k) => v && k)).join(',')}`],
                    offset: 0,
                })
                .count({ resource: 'contracts' }).$promise.then((data) => {
                    $scope.countAU = data.count
                })
            })
        })
        .catch(ErrorCatcher)
    }
    if ($scope.canSeeAUNotif) {
        SocketFactory.join('AU', $scope)
        SocketFactory.register('AU_UPDATE', () => updateAUCount())
        SocketFactory.register('NEW_AU_TICKET', () => {
            $scope.hasNewUrgentCalls = true
            $timeout(() => { $scope.hasNewUrgentCalls = false }, 9000)
            updateAUCount()
        })
        updateAUCount()
    }
    $scope.goToUrgentCalls = () => {
        $state.go('urgentCalls')
        $scope.hasNewUrgentCalls = false
    }

    $rootScope.sgeUrl = () => BoFeaturesService.get('sgeUrl')

    $scope.closeAlert = (index) => AlertManager.closeAlert(index)

    $scope.doLogout = () =>
        ApiUser.logout({}).$promise.then(() => AuthService.logout())

    $scope.isLogged = () => AuthService.isLogged()

    $scope.auth = () => AuthService.getAuth()
    $scope.userName = () => AuthService.getUser()

    $scope.openLoginModal = () => AuthService.openLoginModal()

    $scope.rolesTranslation = _.mapValues(Roles, 'label')

    const reRenderSlider = () => $timeout(() => $rootScope.$broadcast('rzSliderForceRender'))

    $scope.toggleCollapse = function () {
        $scope.collapsed = !$scope.collapsed
        localStorage.leftMenuCollapsed = $scope.collapsed
        reRenderSlider()
    }

    const clientRegexp = new RegExp(`(${$rootScope.clientPrefix})[0-9A-Z]{7}`)
    const contractElecRegexp = new RegExp(`(${$rootScope.contractElecPrefix})[0-9A-Z]{7}`)
    const placeRegexp = new RegExp(`(${$rootScope.placePrefix})[0-9A-Z]{7}`)
    const uuidRegexp = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/
    const prmRegexp = /^([ '"]*\d[ '"]*){14}$/
    const sanitizeSearchRegexp = /[^a-z0-9-]+/ig

    $scope.findByCustomerId = function (search) {
        $scope.isSearching = true
        return Promise.resolve().then(() => {
            let searchString = search
            if (searchString.indexOf('@') > -1) {
                searchString = searchString.toLowerCase().trim()
                $state.go('clients', { mail: searchString }, { reload: true })
            } else if (searchString.match(prmRegexp)) { // PRM
                searchString = searchString.replace(sanitizeSearchRegexp, '')
                $state.go('contracts', { prm: searchString }, { reload: true })
            } else if (searchString.match(contractElecRegexp)) { // CONTRACT ID
                searchString = searchString.replace(sanitizeSearchRegexp, '')
                return DataAccessSearch({ offset: 0, columns: ['id', 'id_account', 'account.customer_id', 'account.category'] })
                .searchPaginated({ resource: 'contracts', id: searchString }).$promise.then((data) => {
                    if (!data.results.length) {
                        return DataAccessSearch({ offset: 0, columns: ['id', 'id_account', 'account.customer_id', 'account.category'] })
                        .searchPaginated({ resource: 'contractdrafts', id: searchString }).$promise.then((draftResult) => draftResult.results[0])
                    }
                    return data.results[0]
                })
                .then((contractElec) => {
                    if (contractElec) {
                        if (!contractElec.id_account) {
                            $state.go('contractDrafts', { id: searchString }, { reload: true }) // anonymous drafts
                        } else {
                            switch (contractElec.category) {
                                case 'pro':
                                    $state.go('pdls', { id_contract: searchString }, { reload: true }) // B2G
                                    break
                                case 'small-business':
                                case 'part':
                                    $state.go('userInfoOnContract', { customerId: contractElec.customer_id, contractId: contractElec.id }, { reload: true }) // B2C
                                    break
                                default:
                                    AlertManager.error(`Type de compte non géré`)
                            }
                        }
                    } else {
                        AlertManager.error(`Aucun résultats`)
                    }
                })
            } else if (searchString.match(clientRegexp)) { // CUSTOMER ID
                searchString = searchString.replace(sanitizeSearchRegexp, '')
                return DataAccessSearch({ offset: 0, columns: ['id', 'category'] }).searchPaginated({ resource: 'accounts', customer_id: searchString }).$promise.then((data) => {
                    if (data.results.length) {
                        switch (data.results[0].category) {
                            case 'pro':
                                AlertManager.error(`Compte B2G, passez par l'écran dédié`) // B2G
                                break
                            case 'small-business':
                            case 'part':
                                $state.go('userInfo', { customerId: searchString }, { reload: true }) // B2C
                                break
                            default:
                                AlertManager.error(`Type de compte non géré`)
                        }
                    } else {
                        AlertManager.error(`Aucun résultats`)
                    }
                })
            } else if (searchString.match(placeRegexp)) { // PLACE ID
                searchString = searchString.replace(sanitizeSearchRegexp, '')
                return DataAccessSearch({ offset: 0, columns: ['id', 'account.customer_id', 'account.category'], orderBy: 'energy_type' })
                .searchPaginated({ resource: 'contracts-common', id_place: searchString }).$promise.then((data) => {
                    if (data.results.length) {
                        return data.results[0]
                    }
                    AlertManager.error(`Aucun résultats`)
                })
                .then((contract) => {
                    if (contract) {
                        switch (contract.category) {
                            case 'pro':
                                $state.go('pdls', { id_contract: contract.id }, { reload: true }) // B2G
                                break
                            case 'small-business':
                            case 'part':
                                $state.go('userInfoOnContract', { customerId: contract.customer_id, contractId: contract.id }, { reload: true }) // B2C
                                break
                            default:
                                AlertManager.error(`Type de compte non géré`)
                        }
                    } else {
                        AlertManager.error(`Aucun résultats`)
                    }
                })
            } else if (searchString.match(uuidRegexp)) { // $urlRouterProvider
                searchString = searchString.replace(sanitizeSearchRegexp, '')
                $state.go('userSearch', { search: searchString }, { reload: true })
            } else {
                $state.go('clients', { name: searchString }, { reload: true })
            }
        }).finally(() => {
            $scope.isSearching = false
        })
    }

    $scope.multiSearch = (search) => {
        return DataAccess.multiSearch({ search }).$promise
        .catch(ErrorCatcher)
    }

    $scope.clickSearchResult = (item) => {
        switch (item.type) {
            case 'DRAFT':
                if (item.category === 'pro') {
                    if (item.energy_type === 'GAS') {
                        $state.go('new-pce', { id_draft: item.id_draft_basic }, { reload: true })
                    } else {
                        // TODO
                    }
                } else {
                    $state.go('userInfoOnContract', { customerId: item.customer_id, contractId: item.id_contract }, { reload: true })
                }
                break
            case 'CONTRACT':
                if (item.category === 'pro') {
                    $state.go('pdls', { id_contract: item.id_contract }, { reload: true })
                } else {
                    $state.go('userInfoOnContract', { customerId: item.customer_id, contractId: item.id_contract }, { reload: true })
                }
                break
            default:
                if (item.category === 'pro') {
                    $state.go('categories', { customer_id: item.customer_id }, { reload: true })
                } else {
                    $state.go('userInfo', { customerId: item.customer_id }, { reload: true })
                }
        }
    }

    // BROADCAST
    $scope.broadcastFields = {
        room: { label: 'Destinataires',
            type: 'select',
            enum: [
                { label: 'Tout le monde', value: undefined },
            ] },
        title: { label: 'Titre', type: 'text' },
        body: { label: 'Message', type: 'textarea' },
        sound: { label: 'Son',
            type: 'select',
            enum: [
                { label: '-- Pas de son --', value: undefined },
                { label: 'Oh yeah !', value: 'oh-yeah' },
                { label: 'Cha ching', value: 'cha-ching' },
            ] },
        delay: { label: 'Durée (ms)', type: 'number' },
        url: { label: 'Lien de la notif',
            type: 'select',
            enum: [
                { label: '-- Pas de lien --', value: undefined },
                { label: 'Release notes', value: '/wiki?title=Release notes' },
                { label: 'Incidents', value: '/wiki?title=Incidents en cours' },
            ] },

    }

    $scope.broadcastPayload = {
        room: undefined,
        title: '',
        body: '',
        sound: undefined,
        delay: 6000,
        url: undefined,
    }

    const template = {
        room: '',
        eventName: 'EVENT',
        payload: {
            type: 'CUSTOM',
            title: '',
            body: '',
            sound: '',
        },
    }

    $scope.broadcast = function () {
        const payload = angular.copy(template)
        if ($scope.broadcastPayload.room) {
            payload.room = $scope.broadcastPayload.room
        } else {
            delete payload.room
        }
        payload.payload.title = $scope.broadcastPayload.title
        payload.payload.body = $scope.broadcastPayload.body
        payload.payload.sound = $scope.broadcastPayload.sound
        payload.payload.delay = $scope.broadcastPayload.delay
        payload.payload.url = $scope.broadcastPayload.url
        return ApiUser.broadcast(payload).$promise.then(() =>
            AlertManager.success('Message envoyé !'))
        .catch(ErrorCatcher)
    }


    const checkEnedisStatus = () =>
        Healthchecks.getEnedisStatus().$promise.then((result) => {
            $scope.isEnedisUp = result.status === 'ok' ? 'ok' : 'ko'
        })


    const activate = function () {
        AccountService.watch('homeCtrl', (account) => {
            if (account && ($state.is('userInfo') || $state.is('contractInfo') || $state.is('userSearch') || $state.is('userInfoOnContract'))) {
                $scope.searchString = account.customer_id
            }
        })

        BoFeaturesService.getFeatures().then((features) => {
            if (features) {
                const envLabels = features.styles
                const env = BoFeaturesService.getEnv()
                const envType = env && env.split('-').pop()

                $scope.envLabel = _.get(envLabels, [envType, 'label'], 'Development')
                $scope.envStyle = _.get(envLabels, [envType, 'style'], 'devel')
                $scope.envLogo = _.get(envLabels, [envType, 'logo'], '')
                $('#dynamic-favicon').attr('href', `/images/assets/img/${_.get(envLabels, `${envType}.favicon`, `favicon_${env}.png`)}`)
            }
            $('#dynamic-favicon').attr('href', `/images/assets/img/favicon_int.png`)
        })

        OrganizationService.getOrgz().then((data) => {
            $scope.broadcastFields.room.enum = [{ label: 'Tout le monde', value: undefined }]
            return _.forEach(data, (d) => $scope.broadcastFields.room.enum.push({ label: d.id, value: d.id }))
        })

        checkEnedisStatus()
        return $interval(checkEnedisStatus, 60000)
    }

    $scope.computeToastText = (notif) => {
        let details = notif.detail
        if (details && !_.isArray(details)) {
            details = [details]
        }
        const notifs = _.map(details, (d) => {
            if (_.isObject(d)) {
                return JSON.stringify(d)
            }
            return d
        }).join('\n\t- ')
        return notif.msg + (details && details.length ? (`: \n\t- ${notifs}`) : '')
    }

    $scope.openCapSupport = () => {
        ApiAdmin.getCapAssignation().$promise.then((cap) => {
            if (!cap.active) {
                return "Désolé, il n'y a pas de support casquette aujourd'hui."
            }
            if (!cap.assigned) {
                return "Désolé, le support casquette n'est pas encore ouvert."
            }
            if (!cap.user) {
                return (cap.confirmed)
                    ? "Désolé, il n'y a pas de support casquette aujourd'hui."
                    : "Désolé, le support casquette n'est pas encore ouvert."
            }

            window.location = cap.user.slack.link
        })
        .then((msg) => {
            if (msg) {
                AlertManager.error(msg)
            }
        })
        .catch(ErrorCatcher)

        return false
    }

    $scope.searchPrm = () =>
        ModalService.openModal({ type: 'prmSearchModal', size: 'xlg' }, { light: true })

    $scope.searchPce = () =>
        ModalService.openModal({ type: 'pceSearchModal', size: 'xlg' }, { light: true })

    $scope.openBatchOperationModal = () =>
        ModalService.openModal({ type: 'batchOperationModal', size: 'xlg', backdrop: 'static' })

    activate()
})
